import { Component, Input } from '@angular/core';

@Component({
  selector: 'fin-destination-search-header',
  templateUrl: './destination-search-header.component.html',
})
export class DestinationSearchHeaderComponent {
  @Input()
  destinationTeaserText?: string;
}
